import React, {useState} from "react";
import ReactQuill from "react-quill";
import {useSelector} from "react-redux";
import {useForm} from "react-hook-form";
import axiosInstant from "../libs/axiosInstant";

import Toast from "../libs/Toast";

function Reply({msg, setOpenReply, reFetch}) {

    const { config: {option, compose} } = useSelector((state) => state.mailBox)
    const {register, handleSubmit, reset, formState: {errors},} = useForm();

    const [message, setMessage] = useState('');
    const handleEditorChange = (value) => {
        setMessage(value);
    };

    const onSubmit = async (data) => {

        const formData = new FormData();
        formData.append('reply_id', msg.message_id);
        formData.append('inbox_id', msg.id);
        formData.append('message_id', msg.message_id);
        formData.append('recipient', msg.from.id);
        formData.append('message', message);
        formData.append('subject', `Re: ${msg.subject}`);

        Array.from(data.attachments).forEach((file) => {
            formData.append('attachments[]', file);
        });

        try {
            const { data } = await axiosInstant.post('/inbox/send', formData, {
                headers: {'Content-Type': 'multipart/form-data',},
            });
            console.log(data, 'data', (data.status ? 'success' : 'error'))
            Toast((data.status ? 'success' : 'error'), data.message)
            if(data.status) {
                setMessage('')
                reset()
                setOpenReply(false)
                reFetch(msg.id);
            }
            /*console.log('response', data);*/
        } catch (error) {
            console.error("There was an error sending the message!", error);
            Toast('error', error);
        }
    }

    return (
        <div className="mailcontent-body">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div>
                    <div className="form-group">
                        <h6>Reply: {msg.subject}</h6>
                    </div>
                    <hr/>
                    <div className="form-group editor-container">
                        <ReactQuill value={message} onChange={handleEditorChange} theme="snow" placeholder="Type something..."/>
                    </div>
                    {option?.message_center?.delete_duration_msg &&
                        <div className="alert alert-warning d-flex align-items-center tab-description m-0 mt-2"
                             role="alert">
                            <i className="ri-error-warning-line ri-2x"></i>
                            <div dangerouslySetInnerHTML={{__html: option.message_center.delete_duration_msg}}/>
                        </div>
                    }
                </div>
                <div className="compose-footer">
                    <div className="d-flex">
                        <button type="submit" className="btn btn-primary btn-icontext"
                                style={{backgroundColor: compose.bgButton, color: compose.colorButton}}>
                            <i className="ri-send-plane-fill me-2"/> Send
                        </button>
                        <button type="button" className="btn btn-secondary btn-icontext ms-1"
                                onClick={() => setOpenReply(false)}>
                            <i className="ri-close-fill me-2"/> Close
                        </button>
                    </div>
                    <label className="btn btn-white btn-icon btn-attach">
                        <i className="ri-attachment-2"/>
                        <input type="file" accept={option.allowed_extensions} {...register('attachments')} multiple/>
                    </label>
                </div>
            </form>
        </div>
    )
}


export default Reply;